import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MAP_ROOT } from '@lassi/config';
import { RouteUtilsService, VicnamesSearchService } from '@lassi/webapp-shared';

export const polygonSearchGuard: CanActivateFn = (route) => {
  const service = inject(VicnamesSearchService);

  if (service.polygonSearch()) {
    return true;
  }

  return inject(Router).createUrlTree(
    [
      inject(MAP_ROOT),
      {
        outlets: {
          [RouteUtilsService.MAP_MENU_OUTLET_NAME]: [
            RouteUtilsService.MAP_MENU_ROOT_PATH,
            'vicnames',
          ],
        },
      },
    ],
    {
      queryParams: route.queryParams,
      queryParamsHandling: 'merge',
    },
  );
};
